<template>
  <div class="flex flex-col py-8 px-12 font-sans-serif">
    <div v-if="!registered">
      <div>
        <span>{{ $t('masterclass.enrolling') }}</span>
        <strong class="uppercase"> {{ masterclass.teacher.name }} </strong>
        <span> {{ $t('masterclass.on') }} </span>
      </div>
      <strong class="uppercase"> {{ dayStart }}. </strong>
      <div class="py-2 mt-4 bg-orange-academy-300 text-white uppercase font-bold"
        v-if="showMessage">
        {{ message }}
      </div>
      <div class="flex mt-16 w-full justify-between items-center" v-if="student">
        <material-label  v-model="student.firstname" class="w-full pr-4"
        :name="$t('skills.firstname')" />
        <material-label v-model="student.lastname" class="w-full"
        :name="$t('skills.lastname')" />
      </div>
      <div class="flex mt-10 w-full justify-between items-center">
        <material-input v-model="form.address" class="w-full"
        :name="$t('skills.address')" />
      </div>
      <div class="flex mt-10 w-full justify-between items-center">
        <material-input v-model="form.city" class="w-full pr-4"
        :name="$t('skills.city')" />
        <material-input v-model="form.postcode" class="w-full"
        :name="$t('skills.postcode')" />
      </div>
      <div class="flex mt-10 w-full justify-between items-center">
        <material-input v-model="form.state" class="w-full pr-4"
        :name="$t('skills.state')" />
        <material-input v-model="form.country" class="w-full"
        :name="$t('skills.country')" />
      </div>
      <div class="flex mt-10 w-full justify-between items-end" v-if="user">
        <material-input v-model="form.phone" class="w-full pr-4"
        :name="$t('skills.phone')" />
        <material-label v-model="user.email" class="w-full"
        :name="$t('skills.email')" />
      </div>
      <div class="flex flex-col mt-12">
        <div class="flex items-start text-left">
          <input type="checkbox" id="privacy" class="mt-1" v-model="privacy">
          <label for="privacy" class="pl-2">
            {{ $t('masterclass.privacy') }}
          </label>
        </div>
        <div class="flex items-start mt-4">
          <input type="checkbox" id="privacy" class="mt-1" v-model="newsletter">
          <label for="privacy" class="pl-2">
            {{ $t('masterclass.newsletter') }}
          </label>
        </div>
      </div>
      <div class="flex justify-center mt-16">
        <button @click="registerToMasterclass"
          class="bg-orange-academy-300 border border-orange-academy-300 px-4 py-3 rounded font-bold
          text-white hover:bg-white hover:text-orange-academy-300 uppercase font-medium">
            {{ $t('masterclass.signme') }}
        </button>
      </div>
    </div>
    <div v-else class="flex flex-col items-center">
      <mail-masterclass-icon class="" />
      <span class="font-bold mt-6 text-xl">{{ $t('masterclass.successRegister') }}</span>
      <span class="mt-2 text-md">{{ $t('masterclass.checkMail') }}</span>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import MaterialInput from '@/components/graphics/MaterialInput.vue';
import MaterialLabel from '@/components/graphics/MaterialLabel.vue';
import { mapGetters } from 'vuex';
import MailMasterclassIcon from '@/components/graphics/MailMasterclassIcon.vue';
import axios from 'axios';

export default {
  props: ['masterclass'],

  data() {
    return {
      form: {
        address: '',
        city: '',
        postcode: '',
        state: '',
        country: '',
        phone: '',
      },

      message: '',
      showMessage: false,

      privacy: false,
      newsletter: false,

      registered: false,
    };
  },

  mounted() {
    if (this.authenticated) {
      Object.keys(this.form).forEach((key) => {
        this.form[key] = this.student[key];
      });
    }
  },

  components: {
    MaterialInput,
    MaterialLabel,
    MailMasterclassIcon,
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
      student: 'auth/student',
    }),

    dayStart() {
      const date = this.masterclass.day ? dayjs.tz(this.masterclass.day, 'UTC') : '';
      return dayjs(date).tz(this.choosenTimezone).format('LL');
    },
  },

  methods: {
    async registerToMasterclass() {
      this.showMessage = false;
      if (this.checkInputs()) {
        await axios.post(`/api/students/${this.student.id}`, this.form);
        axios.put(`/api/masterclasses/${this.masterclass.id}/students/${this.student.id}`).then(() => {
          this.$emit('updated-subscription');
          this.registered = true;
        });
      }
    },

    checkInputs() {
      let ok = true;
      if (!this.privacy) {
        this.message = this.$t('masterclass.pleaseAcceptPrivacy');
        this.showMessage = true;
        ok = false;
      }
      Object.keys(this.form).forEach((key) => {
        if (!this.form[key]) {
          this.message = this.$t('masterclass.pleaseComplete');
          this.showMessage = true;
          ok = false;
        }
      });
      return ok;
    },
  },
};
</script>
